import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

interface CheckboxGradientProps extends CheckboxProps {
  customSize?: number;
}

export const CheckboxGradient = ({ customSize = 25, ...props }: CheckboxGradientProps) => {
  const { disabled } = props;

  return (
    <>
      <svg
        style={{ width: "0", height: "0", position: "absolute" }}
        aria-hidden="true"
        focusable="false"
        width={100}
        height={100}
      >
        <linearGradient id="checkbox-gradient" x2="1" y2="0">
          <stop offset="0%" stopColor="#84FAB0 " />
          <stop offset="100%" stopColor="#8FEAFE" />
        </linearGradient>
      </svg>
      <Checkbox
        {...props}
        icon={<CheckBoxOutlineBlankIcon style={{ height: customSize, width: customSize } as React.CSSProperties} />}
        checkedIcon={
          disabled ?
            <CheckBoxIcon style={{ height: customSize, width: customSize } as React.CSSProperties} /> :
            <CheckBoxIcon style={{ fill: `url(#checkbox-gradient)`, height: customSize, width: customSize } as React.CSSProperties} />
        }
      />
    </>
  )
}
